/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable new-cap */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@material-ui/core';
import GetAppTwoToneIcon from '@material-ui/icons/GetAppTwoTone';
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { min2Time, sec2time } from '../../../../helpers/utils';

function sanitizeForFile(s) {
  return (s || '')
    .toString()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[\\/:"*?<>|]+/g, '');
}

function exportExcel(exportData, semesterName, group) {
  const fullName = `${exportData.name || ''} ${exportData.firstname || ''}`.trim();

  const summary = [
    ['Nom', exportData.name || ''],
    ['Prénom', exportData.firstname || ''],
    ['Semestre', exportData.semester?.toString() || ''],
    ['Session', exportData.catchUp ? 'Session 2' : 'Session 1'],
    ['Date de l\'export', moment(new Date(exportData.exportDate)).format('DD/MM/YYYY à HH:mm')],
    [''],
    ['', 'Résultats', 'Objectifs'],
    ['Taux de réussite (quiz)', `${exportData.percent}%`, `${group.elearning.elearningTarget}%`],
    ['Taux de réalisation (unités)', `${exportData.unitsPercent}%`, `${group.elearning.elearningAttempts}%`],
    ['Temps de connexion total', sec2time(exportData.time), `${min2Time((group.elearning.elearningDuration / 100) * group.elearning.elearningDurationTarget)}`],
  ];

  const wsSummary = XLSX.utils.aoa_to_sheet(summary);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, wsSummary, 'Résumé');

  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const fileName = `Résultats_${sanitizeForFile(fullName)}_${sanitizeForFile(semesterName || '')}.xlsx`;
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName);
}

function exportPDF(exportData, semesterName, group) {
  const fullName = `${exportData.name || ''} ${exportData.firstname || ''}`.trim();

  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'A4' });
  doc.setFontSize(16);
  doc.text(
    `Résultats — ${fullName || 'Student'}${semesterName ? ` — ${semesterName}` : ''}`,
    40,
    40,
  );

  const metaBody = [
    { k: 'Prénom', v: exportData.firstname || '', o: '' },
    { k: 'Nom', v: exportData.name || '', o: '' },
    { k: 'Semestre', v: semesterName || '', o: '' },
    { k: 'Session', v: exportData.catchUp ? 'Session 2' : 'Session 1', o: '' },
    { k: 'Date de l\'export', v: moment(new Date(exportData.exportDate)).format('DD/MM/YYYY à HH:mm'), o: '' },
    { k: '', v: '', o: '' },
    { k: 'Taux de réussite (quiz)', v: `${exportData.percent}%`, o: `${group.elearning.elearningTarget}%` },
    { k: 'Taux de réalisation (unités)', v: `${exportData.unitsPercent}%`, o: `${group.elearning.elearningAttempts}%` },
    { k: 'Temps de connexion total', v: sec2time(exportData.time), o: `${min2Time((group.elearning.elearningDuration / 100) * group.elearning.elearningDurationTarget)}` },
  ];

  doc.autoTable({
    startY: 60,
    headStyles: { fillColor: [216, 78, 75] },
    body: metaBody,
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 4 },
    margin: { left: 40, right: 40 },
  });

  const fileName = `Résultats_${sanitizeForFile(fullName)}_${sanitizeForFile(semesterName || '')}.pdf`;
  doc.save(fileName);
}

const StudentExportButtons = ({
  exportData, semesterName, group,
}) => (
  <ButtonGroup
    variant="contained"
    size="small"
    style={{
      margin: '8px 5',
    }}
    disableElevation
  >
    <Button
      onClick={() => exportExcel(exportData, semesterName, group)}
      startIcon={<GetAppTwoToneIcon />}
      disableElevation
      color="primary"
    >
      Export Excel
    </Button>
    <Button
      onClick={() => exportPDF(exportData, semesterName, group)}
      startIcon={<PictureAsPdfTwoToneIcon />}
      disableElevation
      color="secondary"
    >
      Export PDF
    </Button>
  </ButtonGroup>
);

StudentExportButtons.propTypes = {
  exportData: PropTypes.shape({

  }),
  group: PropTypes.shape({

  }),
  semesterName: PropTypes.string.isRequired,
};

StudentExportButtons.defaultProps = {
  exportData: {},
  group: {},
};

export default StudentExportButtons;
